import { IntegrationProvider } from "dto/Settings/IntegrationProvider";
import { IntegrationType } from "dto/Settings/IntegrationType";

export type { FC } from "react";

export enum ETypes {
  ALL = "ALL",
  PI = "PI",
  EMAIL = "EMAIL",
  WORKSPACE = "WORKSPACE",
  CALENDAR = "CALENDAR",
  CONTACTFORM = "CONTACTFORM",
  EDITOR = "EDITOR",
  FK = "FK",
  EDELIVERY = "EDELVIERY",
  PRIVATEINVITATION = "PRIVATEINVITATION",
  KSEF = "KSeF",
  /** Centralny Rejestr Umów (MF) — klucz API per firma (cruService). */
  CRU = "CRU",
  /** RADIX (WIP / PoGrun / GOK) — łańcuchy połączeń MS SQL per firma (radixService). */
  RADIX = "RADIX",
}

export interface Props {
  // type: IntegrationType;
  // provider: IntegrationProvider;
  // isActive: boolean;
  toggle: () => void;
  integrationId: any;
  handleDisconnect: any;
  onInnerViewSaved: any;
  onInnerViewCanceled: any;
  courtPortalState: any;

  refetchI: any;
  refetchportals: any;

  configureAppleCalendar: boolean;
  setConfigureAppleCalendar: (v: boolean) => void;

  handleClick: (
    type: IntegrationType,
    provider: IntegrationProvider,
    isActive: boolean
  ) => void;
}
